import { CreateAdditionalDischargeBodyDto } from '@ekt-group/general-purpose-api-interfaces';
import { useMutation } from '@tanstack/react-query';

import { mutationFn } from '@/lib/react-query';

const orderAdditionalDischargeFn = (data: CreateAdditionalDischargeBodyDto | CreateAdditionalDischargeBodyDto[]) => {
  return mutationFn(`/self-service/objects/additional-discharges`, data, 'post');
};

export const useOrderAdditionalDischarge = () =>
  useMutation({
    mutationFn: (data: CreateAdditionalDischargeBodyDto | CreateAdditionalDischargeBodyDto[]) => orderAdditionalDischargeFn(data),
  });
